import axios, { AxiosResponse } from 'axios';
import {
  BillingReceiptsReq,
  BillingRenewCheckoutPayload,
  InvoiceSubscriptionRead,
  TAccountReceiptsTable,
} from '@src/types/billing.ts';

export const getBillingsSubscriptions = (): Promise<
  AxiosResponse<InvoiceSubscriptionRead[]>
> => {
  return axios.get(`/billings/subscriptions/`);
};

export const cancelBillingsSubscriptions = (
  id: number
): Promise<AxiosResponse<InvoiceSubscriptionRead[]>> => {
  return axios.post(`/billings/subscriptions/${id}/cancel/`);
};

export const getBillingsReceipts = (
  params?: BillingReceiptsReq
): Promise<AxiosResponse<TAccountReceiptsTable[]>> => {
  return axios.get(`billings/receipts/`, { params });
};

export const getBillingRenewPackage = (id: number) => {
  return axios.get(`/billings/subscriptions/${id}/renews/`);
};

export const checkoutRenewBillingPackage = (
  id: number,
  payload: BillingRenewCheckoutPayload
) => {
  return axios.post(`/billings/subscriptions/${id}/checkout-renews/`, payload);
};
